module.exports = __webpack_public_path__ + "static/img/22.e070745.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background/22.jpg
// module id = PTaW
// module chunks = 0